import { Component, OnDestroy, OnInit } from '@angular/core';
import {
  FormBuilder,
  FormControl,
  FormGroup,
  FormsModule,
  ReactiveFormsModule,
  Validators,
} from '@angular/forms';
import {
  MatCheckboxModule,
  type MatCheckboxChange,
} from '@angular/material/checkbox';
import { MatOption } from '@angular/material/core';
import { MatError, MatFormField, MatLabel } from '@angular/material/form-field';
import { MatIcon } from '@angular/material/icon';
import { MatInput } from '@angular/material/input';
import { MatSelect } from '@angular/material/select';
import { Router } from '@angular/router';
import { NgxPaginationModule } from 'ngx-pagination';
import { NgxSpinnerService } from 'ngx-spinner';
import { ApiServiceService } from '../api-service.service';
import { CommonDropdownSearchComponent } from '../common-component-dropdown-search/common-component-dropdown-search.component';
import { CommonPaginationComponent } from '../common-component-pagination/common-component-pagination.component';
import { CommonSearchComponent } from '../common-component-search/common-component-search.component';
import { OtaInfoComponent } from '../ota-info/ota-info.component';
import { SharedValidators } from '../shared/validators/shared-validators';
import { NgxMatSelectSearchModule } from 'ngx-mat-select-search';
import { Subject, takeUntil } from 'rxjs';

@Component({
  selector: 'app-ota-batch-create',
  templateUrl: './ota-batch-create.component.html',
  styleUrls: ['./ota-batch-create.component.scss'],
  standalone: true,
  imports: [
    FormsModule,
    ReactiveFormsModule,
    MatFormField,
    MatLabel,
    MatInput,
    MatError,
    MatSelect,
    MatOption,
    NgxPaginationModule,
    NgxMatSelectSearchModule,
    MatIcon,
    CommonSearchComponent,
    CommonPaginationComponent,
    CommonDropdownSearchComponent,
    MatCheckboxModule,
    OtaInfoComponent,
  ],
})
export class OtaBatchCreateComponent implements OnInit, OnDestroy {
  private _onDestroy = new Subject<void>();

  // OTA Command List
  config = false;
  paraArr: {
    otaCommand: string;
    name: string;
    example: string;
    id: string;
    otaType: string;
    time: string;
    isInputRequired: boolean;
  }[] = [];

  checkedArr: {
    otaCommand: string;
    name: string;
    example: string;
    _id: string;
    otaType: string;
    timeInMs: string;
    isInputRequired: boolean;
  }[] = [];

  filteredSetCommandList: {
    otaCommand: string;
    name: string;
    example: string;
    _id: string;
    timeInMs: string;
    isInputRequired: boolean;
  }[] = [];

  searchString = '';
  filterSelect = '';
  allSelected = false;

  commandArray: {
    otaCommand: string;
    name: string;
    example: string;
    otaType: string;
    _id: string;
    timeInMs: string;
    isInputRequired: boolean;
  }[] = [];

  otaOverviewFilter = [
    { key: 'All', value: 'All' },
    { key: 'GET', value: 'GET' },
    { key: 'SET', value: 'SET' },
    { key: 'CLR', value: 'CLR' },
  ];

  // Set Configuration Value
  otaListSelected: {
    otaCommand: string;
    name: string;
    example: string;
    id: string;
    time: string;
    isInputRequired: boolean;
    otaType: string;
  }[] = [];

  totalLength = 0;
  page = 1;
  size = 10;
  totalPages = 0;

  // Device List
  page2 = 1;
  size2 = 10;
  searchText = '';
  listOfDevice: {
    uid: string;
    iccid: string;
    imei: string;
    isAssigned: boolean;
    modelName: string;
  }[] = [];

  sampleData: {
    uid: string;
    iccid: string;
    imei: string;
    isAssigned: boolean;
    modelName: string;
  }[] = [];

  totalCount = 0;

  otaCommandFilterCtrl: FormControl = new FormControl();
  ParametersListForm: FormGroup = this.formBuilder.group({});
  filterForm: FormGroup = this.formBuilder.group({});
  CommandForm: FormGroup = this.formBuilder.group({});
  file: File | null = null;
  formGroup: FormGroup = this.formBuilder.group({});
  deviceArray: { imei: string }[] = [];
  otaType = '';

  userPermission: {
    pageName: string;
    view: boolean;
    create: boolean;
    delete: boolean;
    update: boolean;
  }[] = [];

  isFileUploaded = false;

  constructor(
    public apiMicroservice: ApiServiceService,
    public router: Router,
    private formBuilder: FormBuilder,
    private spinner: NgxSpinnerService
  ) {}

  ngOnInit(): void {
    this.checkPermission();
    this.setOtaForm();
  }

  checkPermission() {
    this.userPermission = JSON.parse(
      this.apiMicroservice.decryptData(
        sessionStorage.getItem('userPermission') || '[]'
      )
    );
    this.userPermission.forEach(
      (element: { pageName: string; create: boolean }) => {
        if (element.pageName === 'OTA Batch' && element.create === false) {
          this.navigateBack();
        }
      }
    );
  }

  setOtaForm() {
    this.ParametersListForm = this.formBuilder.group({
      name: new FormControl('', [SharedValidators.requiredAndNoEmptySpaces]),
      description: new FormControl('', [
        SharedValidators.requiredAndNoEmptySpaces,
      ]),
      searchDevice: new FormControl(''),
      otaType: new FormControl(''),
      fileName: new FormControl(''),
      otaCommand: new FormControl(''),
    });
    this.filterForm = this.formBuilder.group({
      filterSelected: new FormControl(''),
    });
    this.otaType = '';
    this.deviceArray = [];
    this.checkedArr = [];
  }

  setOtaBatchType() {
    this.deviceArray = [];
    this.paraArr = [];
    this.checkedArr = [];
    this.otaType = this.ParametersListForm.controls['otaType'].value;
    if (this.otaType === 'manual') {
      this.deviceList();
    }

    const otaCommandControl = this.ParametersListForm.get('otaCommand');
    if (this.otaType === 'custom') {
      otaCommandControl?.setValidators([Validators.required]);
    } else {
      otaCommandControl?.clearValidators();
    }
    otaCommandControl?.updateValueAndValidity();

    this.fetchOtaMaster();
  }

  deviceList() {
    this.spinner.show();
    this.apiMicroservice
      .getDeviceDashboardList(
        'total',
        this.page2,
        this.size2,
        this.searchText,
        ''
      )
      .subscribe((res) => {
        if (res.status) {
          this.listOfDevice = res.data.data;
          this.totalCount = res.data.totalItems;
          this.sampleData = [];
          this.listOfDevice.forEach((element) => {
            this.sampleData.push(element);
          });
          this.deviceArray.map((element: { imei: string }) => {
            this.sampleData.map(
              (listElement: { imei: string; isAssigned: boolean }) => {
                if (element.imei === listElement.imei) {
                  listElement.isAssigned = true;
                }
              }
            );
          });
          this.apiMicroservice.openSnackbar('Fetched Successfully');
          this.spinner.hide();
        } else {
          this.apiMicroservice.openSnackbar('Something went wrong');
          this.spinner.hide();
        }
      });
  }

  onSearch(event: string) {
    this.page2 = 1;
    this.searchText = event;
    this.deviceList();
  }

  onPageChange(event: number) {
    this.page2 = event;
    this.deviceList();
  }

  onSizeChange(event: number) {
    this.page2 = 1;
    this.size2 = event;
    this.deviceList();
  }

  fetchOtaMaster() {
    this.spinner.show();

    this.apiMicroservice
      .getOtaCommandList(1, 10000, this.searchString, this.filterSelect)
      .subscribe({
        next: (res) => {
          this.commandArray = res.data;

          if (this.otaType === 'custom') {
            this.filteredSetCommandList = this.filterSetCommandList(
              this.commandArray
            );
            this.otaCommandFilterCtrl.valueChanges
              .pipe(takeUntil(this._onDestroy))
              .subscribe((search: string) => {
                if (!search) {
                  this.filteredSetCommandList = this.filterSetCommandList(
                    this.commandArray
                  );
                  return;
                }

                const lowerSearch = search.toLowerCase();
                this.filteredSetCommandList = this.filterSetCommandList(
                  this.commandArray
                ).filter((cmd) =>
                  cmd?.otaCommand?.toLowerCase().includes(lowerSearch)
                );
              });
          } else {
            this.filteredSetCommandList = [...this.commandArray];
          }

          this.spinner.hide();
        },
        error: (err) => {
          this.apiMicroservice.openSnackbar(err.message);
          this.commandArray = [];
          this.spinner.hide();
        },
      });
  }

  filterSetCommandList(
    commandList: {
      otaCommand: string;
      name: string;
      example: string;
      _id: string;
      timeInMs: string;
      isInputRequired: boolean;
    }[]
  ) {
    return commandList.filter((item) => {
      if (item.otaCommand && item.otaCommand.startsWith('*SET#')) {
        const parts = item.otaCommand.split('#');
        return parts.length < 3 || parts[2] === '';
      }
      return false;
    });
  }

  usedCommandValueForCustomOTA: {
    _id: string;
    name: string;
    otaCommand: string;
    value: string;
    isInputRequired: boolean;
    otaType: string;
    timeInMs: string;
  } = {
    _id: '',
    name: '',
    otaCommand: '',
    value: '',
    isInputRequired: false,
    otaType: '',
    timeInMs: '',
  };
  usedCommandNameForCustomOTA = '';
  onCommandSelect(selectedCmd: {
    _id: string;
    name: string;
    otaCommand: string;
    value: string;
    isInputRequired: boolean;
    otaType: string;
    timeInMs: string;
  }) {
    this.usedCommandNameForCustomOTA = selectedCmd.name;
    this.usedCommandValueForCustomOTA = selectedCmd;
  }

  filterSelected(event: string) {
    this.filterSelect = event;
    this.fetchOtaMaster();
  }

  onSearchOtaCommandList(event: string) {
    this.searchString = event;
    this.fetchOtaMaster();
  }

  onFileChange(event: Event) {
    const input = event.target as HTMLInputElement;

    if (input.files && input.files.length > 0) {
      this.file = input.files[0];

      this.ParametersListForm.patchValue({
        fileName: this.file.name,
      });
      this.isFileUploaded = true;
    } else {
      this.file = null;

      this.ParametersListForm.patchValue({
        fileName: '',
      });
      this.isFileUploaded = false;
    }
  }

  ngOnDestroy() {
    this._onDestroy.next();
    this._onDestroy.complete();
  }

  toggleSelectAll() {
    this.spinner.show();
    if (this.allSelected) {
      // Deselect all
      this.checkedArr = [];
    } else {
      // Select all
      this.checkedArr = [...this.commandArray];
    }
    this.config = false;
    this.allSelected = !this.allSelected; // Toggle the state
    this.spinner.hide();
  }

  getPaginatedItems() {
    const startIndex = Number(this.page - 1) * Number(this.size);
    const endIndex = Number(startIndex) + Number(this.size);
    return this.paraArr.slice(Number(startIndex), Number(endIndex));
  }

  changePage(page: number) {
    if (page >= 1 && page <= Math.ceil(this.paraArr.length / this.size)) {
      this.page = page;
      this.otaListSelected = this.getPaginatedItems();
    }
  }

  changeSize(size: number) {
    this.size = size; // Update page size
    this.page = 1; // Reset to first page
    this.otaListSelected = this.getPaginatedItems(); // Refresh paginated items
  }

  submit() {
    if (window.confirm('Are you sure?')) {
      if (!this.ParametersListForm.valid) {
        this.ParametersListForm.markAllAsTouched();
        this.apiMicroservice.openSnackbar('Please fill the form');
        return;
      }

      if (this.CommandForm.invalid) {
        this.CommandForm.markAllAsTouched();
        this.apiMicroservice.openSnackbar(
          'Please give input to all selected commands to submit the batch.'
        );
        return;
      }
      const CommandFormData = this.CommandForm.value;

      const ParametersListPayload = this.ParametersListForm.getRawValue();
      const payload = {
        name: ParametersListPayload.name,
        description: ParametersListPayload.description,
        deviceArray: this.deviceArray,
        createdBy: this.apiMicroservice.decryptData(
          sessionStorage.getItem('userRefId') || ''
        ),
        commandArray: this.checkedArr.map((cmd) => ({
          _id: cmd._id,
          name: cmd.name,
          otaCommand: cmd.otaCommand,
          value: cmd.isInputRequired
            ? CommandFormData[cmd.otaCommand] || ''
            : '',
          isInputRequired: cmd.isInputRequired,
          otaType: cmd.otaType,
          timeInMs: cmd.timeInMs,
        })),
      };
      this.spinner.show();

      if (this.deviceArray.length === 0 && this.otaType === 'manual') {
        this.apiMicroservice.openSnackbar('Please select at least one device.');
        return;
      }

      if (this.otaType === 'manual') {
        this.apiMicroservice.createManualOtaBatch(payload).subscribe({
          next: (res) => {
            if (res.status) {
              this.spinner.hide();
              this.apiMicroservice.openSnackbar('Ota Batch Added');

              setTimeout(() => {
                this.redirect('Ota-batch-list');
              }, 500);
            } else {
              this.spinner.hide();
              this.apiMicroservice.openSnackbar(res.message);
            }
          },
          error: (error) => {
            this.spinner.hide();
            this.apiMicroservice.openSnackbar(error.message);
          },
        });
      }

      if (this.otaType === 'bulk') {
        this.apiMicroservice.createBulkOtaBatch(payload, this.file!).subscribe({
          next: (res) => {
            if (res.status) {
              this.spinner.hide();
              this.apiMicroservice.openSnackbar('Ota Batch Added');

              setTimeout(() => {
                this.redirect('Ota-batch-list');
              }, 500);
            } else {
              this.spinner.hide();
              this.apiMicroservice.openSnackbar(res.message);
            }
          },
          error: (error) => {
            this.spinner.hide();
            this.apiMicroservice.openSnackbar(error.message);
          },
        });
      }
    } else {
      this.apiMicroservice.openSnackbar('Form submission cancelled.');
      this.SubmitCommandArray();
    }
  }

  SubmitCommandArray() {
    this.size = 10;
    this.page = 1;
    this.ParametersListForm.markAllAsTouched();
    this.paraArr = [];
    this.checkedArr.forEach((element) => {
      this.paraArr.push({
        otaCommand: element.otaCommand,
        name: element.name,
        example: element.example,
        otaType: element.otaType,
        id: element._id,
        time: element.timeInMs,
        isInputRequired: element.isInputRequired,
      });
    });
    const formGroupObject: any = {};
    this.paraArr.forEach(
      (elm: {
        otaCommand: string;
        name: string;
        example: string;
        id: string;
        time: string;
        isInputRequired: boolean;
      }) => {
        // Create a disabled form control
        formGroupObject[elm.otaCommand] = new FormControl(
          {
            value: '',
            disabled: !elm.isInputRequired,
          },
          elm.isInputRequired ? [SharedValidators.requiredAndNoEmptySpaces] : []
        );
      }
    );
    this.CommandForm = this.formBuilder.group(formGroupObject);
    this.totalLength = this.paraArr.length;
    if (this.totalLength > 0) {
      this.config = true;
    }
    this.otaListSelected = this.getPaginatedItems();
  }

  submitCustomOta() {
    this.ParametersListForm.markAllAsTouched();
    if (window.confirm('Are you sure?')) {
      if (this.ParametersListForm.valid) {
        const ParametersListPayload = this.ParametersListForm.value;
        const payload: {
          command: {
            _id: string;
            name: string;
            otaCommand: string;
            value: string;
            isInputRequired: boolean;
            otaType: string;
            timeInMs: string;
          };
          name: string;
          description: string;
          createdBy: string;
        } = {
          name: ParametersListPayload.name,
          description: ParametersListPayload.description,
          createdBy: this.apiMicroservice.decryptData(
            sessionStorage.getItem('userRefId') || ''
          ),
          command: {
            _id: this.usedCommandValueForCustomOTA._id,
            name: this.usedCommandValueForCustomOTA.name,
            otaCommand: this.usedCommandValueForCustomOTA.otaCommand,
            value: '',
            isInputRequired: this.usedCommandValueForCustomOTA.isInputRequired,
            otaType: this.usedCommandValueForCustomOTA.otaType,
            timeInMs: this.usedCommandValueForCustomOTA.timeInMs,
          },
        };

        this.spinner.show();
        this.apiMicroservice
          .createCustomOtaBatch(payload, this.file!)
          .subscribe({
            next: (res) => {
              if (res.status) {
                this.spinner.hide();
                this.apiMicroservice.openSnackbar('Ota Batch Added');

                setTimeout(() => {
                  this.redirect('Ota-batch-list');
                }, 500);
              } else {
                this.spinner.hide();
                this.apiMicroservice.openSnackbar(res.message);
              }
            },
            error: (error) => {
              this.spinner.hide();
              this.apiMicroservice.openSnackbar(error.message);
            },
          });
      } else {
        this.CommandForm.markAllAsTouched();
        this.apiMicroservice.openSnackbar(
          'Please give input to all selected commands to submit the batch.'
        );
      }
    } else {
      this.apiMicroservice.openSnackbar('Form submission cancelled.');
    }
  }

  deleteCommand(id: string) {
    this.paraArr = this.paraArr.filter((item) => item.id !== id);
    this.checkedArr = this.checkedArr.filter((item) => item._id !== id);
    this.SubmitCommandArray();
    this.getPaginatedItems();
  }

  clearCommand(otaCommand: string | number) {
    this.CommandForm.controls[otaCommand].setValue('');
  }

  onViewChange(
    e: { target: { checked: boolean } },
    data: {
      uid: string;
      iccid: string;
      imei: string;
      isAssigned: boolean;
      modelName: string;
    }
  ) {
    if (e.target.checked) {
      const alreadyExists = this.deviceArray.some(
        (item) => item.imei === data.imei
      );

      if (!alreadyExists) {
        this.deviceArray.push({
          imei: data.imei,
        });
      }
    } else {
      this.deviceArray = this.deviceArray.filter(
        (item) => item.imei !== data.imei
      );
    }

    this.checkedArr = [];
    this.paraArr = [];
    this.config = false;
  }

  addToCheckedArray(
    event: MatCheckboxChange,
    item: {
      otaCommand: string;
      name: string;
      example: string;
      otaType: string;
      _id: string;
      timeInMs: string;
      isInputRequired: boolean;
    }
  ) {
    if (event.checked) {
      this.checkedArr.push(item);
    } else {
      this.checkedArr = this.checkedArr.filter(
        (checkedItem) => checkedItem._id !== item._id
      );
    }
  }

  checkChecked(item: {
    otaCommand: string;
    name: string;
    example: string;
    _id: string;
    timeInMs: string;
    isInputRequired: boolean;
  }): boolean {
    for (const checkedItem of this.checkedArr) {
      if (item._id === checkedItem._id) {
        return true;
      }
    }
    return false;
  }

  downloadMyFile(): void {
    const link: HTMLAnchorElement = document.createElement('a');
    link.setAttribute('target', '_blank');
    if (this.otaType === 'bulk') {
      link.setAttribute(
        'href',
        '../../assets/downloadableSampleFiles/Sample_OTA_Sheet.csv'
      );
      link.setAttribute('download', 'Sample_OTA_Sheet.csv');
    }

    if (this.otaType === 'custom') {
      link.setAttribute(
        'href',
        '../../assets/downloadableSampleFiles/Custom_OTA_Sample_File.csv'
      );
      link.setAttribute('download', 'Sample_Custom_OTA_Sheet.csv');
    }

    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link); // Remove the link after the download is complete
  }

  navigateBack() {
    this.apiMicroservice.back();
  }

  redirect(to: string): void {
    this.router.navigate([to]);
  }
}
